// extracted by mini-css-extract-plugin
export default {"form":"Forgot_form__w27YJ","input":"Forgot_input__TALOU","helpMessage":"Forgot_helpMessage__b9cz2"};